// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// `localStorage` doesn't exist under Node (SSR). Only wire persistent auth
// storage in the browser; on the server the client is effectively stateless.
const isBrowser = typeof window !== "undefined";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: isBrowser
    ? {
        storage: localStorage,
        persistSession: true,
        autoRefreshToken: true,
      }
    : {
        persistSession: false,
        autoRefreshToken: false,
      },
});